<div
	class="card-footer d-sm-flex justify-content-sm-end align-items-sm-center py-sm-2">
	<ng-content></ng-content>
</div>
